export const SUBSCRIPTION_TIERS = {
  BUSINESS_PRO: 'BUSINESS_PRO',
  ENTERPRISE_PRO: 'ENTERPRISE_PRO'
};

export const SUBSCRIPTION_FEATURES = {
  [SUBSCRIPTION_TIERS.BUSINESS_PRO]: {
    name: 'Business Pro',
    maxUsers: 10,
    maxStorage: 10 * 1024 * 1024 * 1024, // 10GB
    features: [
      'Basic crisis management tools',
      'Limited document access',
      'Basic reporting',
      'Email support'
    ],
    allowedDocuments: [
      'crisis_plan',
      'business_continuity_plan',
      'crisis_communication_plan',
      'vendor_risk_management_plan',
      'high_risk_travel_plan',
      'post_incident_report'
    ]
  },
  [SUBSCRIPTION_TIERS.ENTERPRISE_PRO]: {
    name: 'Enterprise Pro',
    maxUsers: -1, // Unlimited
    maxStorage: 100 * 1024 * 1024 * 1024, // 100GB
    features: [
      'Full crisis management suite',
      'Unlimited document access',
      'Advanced reporting',
      'Priority support',
      'Custom integrations',
      'API access'
    ],
    allowedDocuments: 'all' // Access to all document types
  }
};

export function getSubscriptionFeatures(tier) {
  return SUBSCRIPTION_FEATURES[tier] || SUBSCRIPTION_FEATURES[SUBSCRIPTION_TIERS.BUSINESS_PRO];
}

export function hasDocumentAccess(tier, documentType) {
  const features = getSubscriptionFeatures(tier);
  return features.allowedDocuments === 'all' || features.allowedDocuments.includes(documentType);
}

export function getMaxUsers(tier) {
  const features = getSubscriptionFeatures(tier);
  return features.maxUsers;
}

export function getMaxStorage(tier) {
  const features = getSubscriptionFeatures(tier);
  return features.maxStorage;
} 